import { Box, Button, Grid, Typography } from '@mui/material';
import type { FunctionComponent } from 'react';
import type { IQueueSettings, IVisitorHelproom } from './../../modules/algebra/waiting-room';
import { FederatedHelproomStatus } from './WaitingRoomHelproom';

interface HelpResourcesProps {
  queueSettings: IQueueSettings;
  helproom_open?: boolean;
  task_sid: string;
  helproom: IVisitorHelproom | undefined;
  captcha_enabled: string | undefined;
  captcha_token: string | undefined;
}

const HelpResources: FunctionComponent<HelpResourcesProps> = ({ queueSettings, task_sid, helproom, helproom_open = false, captcha_enabled, captcha_token }) => {
  const chatbot_enabled = queueSettings?.webchat_chatbotenabled;
  const helproom_enabled = queueSettings?.webchat_helproomenabled && helproom_open;
  const both_services_enabled = chatbot_enabled && helproom_enabled;
  const language = queueSettings?.webchat_language;

  return (
    <Grid container spacing={4} className="pt-4">
      {language == 'en' && (
        <Grid item sm={both_services_enabled ? 4 : chatbot_enabled || helproom_enabled ? 6 : 12}>
          <Box className="p-3 bg-tc-6">
            <Box className="flex justify-between flex-box-center">
              <Typography variant="h1" className="text-base font-bold">
                Youth Helproom
              </Typography>
              <Button className="button-primary custom-button" onClick={() => window.open('https://rainn.org/youth-helproom', '_blank')}>
                Youth Helproom
              </Button>
            </Box>
            <Typography variant="body1" className="text-base mt-3">
              Join scheduled, moderated group chat sessions about topics relevant for young people who are experiencing or have experienced sexual assault.
            </Typography>
          </Box>
        </Grid>
      )}
      {chatbot_enabled && (
        <Grid item sm={both_services_enabled ? 4 : 6}>
          <Box className="p-3 bg-tc-6">
            <Box className="flex justify-between flex-box-center">
              <Typography variant="h1" className="text-base font-bold">
                Helpful Resources
              </Typography>
              <Button className="button-primary custom-button">Use our Chatbot</Button>
            </Box>
            <Typography variant="body1" className="text-base">
              It takes a lot of strength to reach out for support. You will be connected with a trained support specialist shortly. We want you to know—you are not alone.
            </Typography>
            <Typography variant="body1" className="text-base mt-3">
              While you are waiting, we invite you to read through the articles below to learn more about healing from trauma.
            </Typography>
          </Box>
        </Grid>
      )}
      {queueSettings?.webchat_helproomenabled && helproom_open && (
        <Grid item sm={both_services_enabled ? 4 : 6}>
          <Box className="px-3  bg-tc-6">
            {/* this module is federated from  helprooms */}
            <FederatedHelproomStatus helproom={helproom} unique_identity={task_sid} captcha_token={captcha_token} captcha_enabled={captcha_enabled} />
          </Box>
        </Grid>
      )}
    </Grid>
  );
};

export default HelpResources;
